import { render, staticRenderFns } from "./BlockListRte.vue?vue&type=template&id=16d45af8&"
import script from "./BlockListRte.vue?vue&type=script&lang=js&"
export * from "./BlockListRte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports